window.variantChanged = false;
window.translationsText = window.translationsText || {};
window.translationsText.stickyFilled = 'Visualizza la selezione dei colori';
window.translationsText.farbe = 'Kleur';
window.translationsText.design = 'Design';
window.translationsText.buttonUnfilled = 'Kies je Design';
window.translationsText.optionale = 'Optioneel Design';
if ($('body').hasClass('set_refil_new_dip') || $('body').hasClass('set_starter_new_dip')) {
    window.translationsText.design = window.translationsText.farbe;
    window.translationsText.buttonUnfilled = 'Kies je Kleur';
     window.translationsText.optionale = 'Optioneel Kleur';
}
else if ($('body').hasClass('all_in_one_special_set')) {
    window.translationsText.design = 'Product';
   window.translationsText.buttonUnfilled = 'Kies uw Product';
     window.translationsText.optionale = 'Optioneel Product';
}
// $(window).on('load', function() {
//     function checkPremiumSelect() {
//         $('.block-swatch.custom-po-set').each(function() {
//             let text = $(this).find('input').val();
//             if (text && (text.includes('Premium') || text.includes('premium') || text.includes('5'))) {
//                 $(this).find('input').trigger('click'); 
//             }
//         });
//     }
    
//     function intervalCheckSelect() {
//         if (window.location.href.includes("variant=")) {
//             let checkedValue = $('.custom-po-set .block-swatch__radio:checked').val();
//             if (checkedValue && (checkedValue.includes('Premium') || checkedValue.includes('premium') || checkedValue.includes('5'))) {
//                     $('.block-swatch.custom-po-set').each(function() {
//                         $(this).css('pointer-events', 'unset');
//                         $(this).find('.block-swatch__item').css('cursor', 'pointer');
//                     });
//                 $('.custom-po-set .block-swatch__radio:checked').trigger('click');
//                 clearInterval(intervalIdSelect);
//             } else {
//                 checkPremiumSelect();
//             }
//         } else {
//             checkPremiumSelect();
//         }
//     }
    
//     let intervalIdSelect = setInterval(intervalCheckSelect, 200);
// });

$(document).ready(function() {

  
  $('.manikure_filter.all_in_one_filter').on('click', function(e) {
    e.preventDefault();
    $('.tag-wrapper.active').click();
    if ($(this).hasClass('active_filter')) {
      $('.manikure_pedikure_filter span').removeClass('active_filter');
      $("color-choose-drawer .product-tile-item").each(function() {
        if ($(this).is('[hidden]') == false) {
          $(this).show();
        } 
      })

    } else {

      $('.manikure_pedikure_filter span').removeClass('active_filter')
      $(this).addClass("active_filter");
      $("color-choose-drawer .product-tile-item").each(function() {
        if ($(this).is('[hidden]') == false) {
          if ($(this).hasClass('pfilter_manicure')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } 
      })
    }
  })


  $('.pedikure_filter.all_in_one_filter').on('click', function(e) {
    e.preventDefault();
    $('.tag-wrapper.active').click();
    if ($(this).hasClass('active_filter')) {
      $('.manikure_pedikure_filter span').removeClass('active_filter');
      $("color-choose-drawer .product-tile-item").each(function() {
        if ($(this).is('[hidden]') == false) {
          $(this).show();
        } 
      })

    } else {

      $('.manikure_pedikure_filter span').removeClass('active_filter')
      $(this).addClass("active_filter");
      $("color-choose-drawer .product-tile-item").each(function() {
        if ($(this).is('[hidden]') == false) {
          if ($(this).hasClass('pfilter_pedicure')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } 
      })
    }
  })

  $('body').on('click', '.manikure_filter:not(.all_in_one_filter)', function(e) {
    e.preventDefault();
    $('.tag-wrapper.active').click();
    if ($(this).hasClass('active_filter')) {
    $('.manikure_pedikure_filter span').removeClass('active_filter');
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      $(this).show();
    })
    } else {
    $('.manikure_pedikure_filter span').removeClass('active_filter')
    $(this).addClass("active_filter");
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      if ($(this).hasClass('pfilter_pedikure')) {
        $(this).hide();
      } else {
        $(this).show();
      }
    })
    }
  })
  
  
  $('body').on('click', '.pedikure_filter:not(.all_in_one_filter)', function(e) {
    e.preventDefault();
    $('.tag-wrapper.active').click();
    if ($(this).hasClass('active_filter')) {
    $('.manikure_pedikure_filter span').removeClass('active_filter');
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      $(this).show();
    })
    } else {
    $('.manikure_pedikure_filter span').removeClass('active_filter')
    $(this).addClass("active_filter");
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      if (!$(this).hasClass('pfilter_pedikure')) {
        $(this).hide();
      } else {
        $(this).show();
      }
    })
    }
  })
  

  $('body').on('click', '.color_selecor_drawer', function(e) {
        $('html, body').animate({
          scrollTop: $('#pick-color-id').offset().top - 100
        }, 100);
        $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
    });
  
    // var $span = $('<span class="Premium_text_top">Più popolari!</span>');
    // var $target = $('.block-swatch.custom-po-set:nth-child(2)');
    // $target.prepend($span);

      $('.block-swatch.custom-po-set').each(function () {
        let text = $(this).find('.block-swatch__item').text();
        if (text.includes('Premium') || text.includes('premium')) {
          $(this).prepend($('<span class="Premium_text_top">Più popolari!</span>'));
        }
     })

    
      $('body').on('click', '.whats-in-set[aria-controls="whats-in-set"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).attr("aria-expanded", "true");
        $('html').addClass('lock-all');
        $('whats-in-set#whats-in-set').attr('open', '')
    })

    
          $('body').on('click', "whats-in-set#whats-in-set .popup-close", function(e) {
        $('.whats-in-set[aria-controls="whats-in-set"]').attr("aria-expanded", "false");
        $('whats-in-set#whats-in-set').removeAttr('open');
        $('html').removeClass('lock-all');
    });

    $('body').on('click', 'color-switcher.color-selection__image', function(e) {
        e.preventDefault();
          if (!$("body").hasClass("color_ab_test")) {
              $('color-switcher.color-selection__image').each(function() {
                  $(this).attr("aria-expanded", "false");
                  $(this).closest('.color-selection__grid-item').removeClass('active');
              })
      
              if ($(this).hasClass('coladded')) {
                  $(this).closest('.color-selection__grid-item').addClass('active');
                  $(this).attr("aria-expanded", "true");
              } else {
                  $('color-switcher.color-selection__image.readytoselect').closest('.color-selection__grid-item').addClass('active');
                  $('color-switcher.color-selection__image.readytoselect').attr("aria-expanded", "true");
              }
      
              $('html').addClass('lock-all');
              $('color-choose-drawer#color-choose-drawer').attr('open', '')
            
          } else {
            
            if ($(this).hasClass('coladded')) {
                // $(this).closest('.color-selection__grid-item').addClass('active');
                // $(this).attr("aria-expanded", "true");
            } else {
              
                $('color-switcher.color-selection__image').each(function() {
                    $(this).attr("aria-expanded", "false");
                    $(this).closest('.color-selection__grid-item').removeClass('active');
                })
              
                $('color-switcher.color-selection__image.readytoselect').closest('.color-selection__grid-item').addClass('active');
                $('color-switcher.color-selection__image.readytoselect').attr("aria-expanded", "true");
    
                $('html').addClass('lock-all');
                $('color-choose-drawer#color-choose-drawer').attr('open', '');
              
            }
          }

    });


const currentUrl = window.location.href;
const decodedUrl = decodeURIComponent(currentUrl);
const urlParams = new URLSearchParams(decodedUrl.split('?')[1]);
const freeVariants = urlParams.get('free_ids')?.split(',') || [];
const discountedVariants = urlParams.get('optional_ids')?.split(',') || [];
const filteredFreeVariants = freeVariants.filter(Boolean);
const filteredDiscountedVariants = discountedVariants.filter(Boolean);
const setId = urlParams.get('set_id');
  
let urlParts = currentUrl.split('&optional_ids');
if (filteredFreeVariants && filteredFreeVariants.length > 0) {
   urlParts = currentUrl.split('&free_ids');
} 
const newUrl = urlParts[0];
console.log('newUrl', newUrl) 
window.history.replaceState(null, document.title, newUrl);

  
function processVariants(variants, selector, delay) {
  return new Promise((resolve) => {
    let completedIterations = 0;

    // Sentry DOONAILS-DE-218 (2026-10-12): $ ist hier nicht immer jQuery.
    Object.keys(variants || {}).forEach(function (k) {
      var index = isNaN(k) ? k : Number(k), value = variants[k];
      setTimeout(() => {
        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $(`${selector}:not(.coladded)`)
          .first()
          .attr("aria-expanded", "true");
        } else {
          $(`${selector}[aria-expanded="false"]:not(.coladded)`)
          .first()
          .attr("aria-expanded", "true");
        }

        $(`color-choose-drawer#color-choose-drawer .product-tile-item[data-variant='${value}']`)
          .trigger("click");

        // Increment the counter and check if all iterations are complete
        completedIterations++;
        if (completedIterations === variants.length) {
          resolve(); // Resolve the promise once all iterations are done
        }
      }, delay);
    });
  });
}


if (filteredFreeVariants && filteredFreeVariants.length > 0) {
  processVariants(filteredFreeVariants, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    if (filteredDiscountedVariants && filteredDiscountedVariants.length > 0) {
      return processVariants(filteredDiscountedVariants, '#pick-color-id color-switcher.color-selection__image.optional-switcher', 200);
    } else {
      return true;
    }
  })
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('set-id', setId);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateProduct');
  });
} else if (filteredDiscountedVariants && filteredDiscountedVariants.length > 0) {
  processVariants(filteredDiscountedVariants, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('set-id', setId);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateProduct');
  });
}



document.addEventListener('variant:changed', function(event) {  
  let eventVariant = event.detail.variant;
  window.variantChanged = false;
  let isColorArray = false;
  let isVariantsArray = false;
  let pre_color_array;
  let preSetId;

  if ($('.color_selected_main .selected_item.coladded').length > 0) {
     $('.color_selected_main .selected_item.coladded').css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
     $('.color_selected_main .selected_item.coladded').removeClass('coladded');
     $('.color_selected_main .selected_item.coladded').removeAttr('variant-id');
  }

  // If we're in the "single products" flow, grab the existing color-array
  if ($('.inventory-product').hasClass('updateSingleProducts')) {
    pre_color_array = $('.inventory-product').attr('color-array');
    isColorArray = true;
  }

  // Collect all selected variant IDs
  const selectedVariantsArray = [];
  let totalColors = parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-free-colors'));
  if ($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-optional-colors')) {
    totalColors = totalColors + parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-optional-colors'));
  }
  
  $('color-switcher.color-selection__image.coladded').each(function (index) {
    if (totalColors > index) {
      selectedVariantsArray.push($(this).attr('variant-id'));      
    }    
  });

  /* DN 2026-10-03 (Jana): Mix & Match Set - beim Wechsel auf weniger Designs (6 -> 4) fielen die ueberzaehligen weg und kamen beim
     Zurueckwechseln nicht wieder ("Waehle Dein Design 5"). Die nicht eingesetzten merken (window.dnRfUeber) und bei einer Variante mit
     mehr Pflichtplaetzen (data-free-colors) hinten wieder anfuegen - nie in den bezahlten optionalen Platz. Welche wirklich fehlen,
     steht erst nach dem Einsetzen fest (das Theme setzt in den optionalen Platz nicht zuverlaessig ein, gemessen 2026-10-03).
     Nur auf den Refill-Vorlagen, auf denen die gewaehlten Designs als Felder auf der Seite stehen. */
  let dnRfAlle = null;
  if (document.body.classList.contains('template_suffix_set_refil_new_pr_on') || document.body.classList.contains('template_suffix_set_refil_new_gel')) {
    /* Stand vor dem Wechsel (siehe change-Merker am Dateiende): hier ist die Auswahl schon auf die neue Variante gekuerzt */
    dnRfAlle = (window.dnRfVorher || $('color-switcher.color-selection__image.coladded').map(function () { return $(this).attr('variant-id'); }).get())
      .concat(window.dnRfUeber || []);
    window.dnRfVorher = null;
    const dnFrei = parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-free-colors'), 10) || 0;
    while (selectedVariantsArray.length < dnFrei && selectedVariantsArray.length < dnRfAlle.length) {
      selectedVariantsArray.push(dnRfAlle[selectedVariantsArray.length]);
    }
  }

  // If we're in the "set" flow, grab the existing set-id
  if ($('.inventory-product').hasClass('updateProduct')) {
    preSetId = $('.inventory-product').attr('set-id');
    isVariantsArray = true;
  }

  processVariants(selectedVariantsArray, '#pick-color-id color-switcher.color-selection__image', 200)
    .then(() => {
      if (isVariantsArray) {
        $('form button.inventory-product[data-product-add-to-cart-button]')
          .attr('set-id', preSetId)
          .addClass('updateProduct');
      }
      return true;
    })
    .then(() => {
      if (isColorArray) {
        $('form button.inventory-product[data-product-add-to-cart-button]')
          .attr('color-array', pre_color_array)
          .addClass('updateSingleProducts');
      }
      return true;
    })
    .then(() => {
      window.variantChanged = true;
      if (dnRfAlle) {
        setTimeout(() => {
          window.dnRfUeber = dnRfAlle.slice($('#pick-color-id color-switcher.color-selection__image.coladded').length);
        }, 600);
      }
      return true;
    });
});

const singleVariants = urlParams.get('single_colors')?.split(',') || [];
const filteredSingleVariants = singleVariants.filter(Boolean);  
const urlSingleParts = decodedUrl.split('&single_colors');
const newSingleUrl = urlSingleParts[0];
window.history.replaceState(null, '', newSingleUrl);

let singleVariantsArray = [];
let singleVariantsString = '';
filteredSingleVariants.forEach((item) => {
  let itemParts = item.split(':');
  if (singleVariantsString != '') {
    singleVariantsString = singleVariantsString + ',' + item;
  } else {
    singleVariantsString = item;
  }
  singleVariantsArray.push(itemParts[0]);
});

if (singleVariantsArray.length > 0) {
  processVariants(singleVariantsArray, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('color-array', singleVariantsString);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateSingleProducts');
    return true;
  });
}


  

    $("body").on("click", "color-choose-drawer#color-choose-drawer .product-tile-item", function(e) {
        var target = $(e.target);
        const $this = $(this);
      
      if (!target.hasClass('dot') 
        && !target.hasClass('flickity-page-dot') 
        && !target.hasClass('quantity_minus') 
        && !target.hasClass('flickity-button') 
        && !target.hasClass('flickity-page-dots') 
        && !target.hasClass('flickity-button-icon')
        && !target.hasClass('color_zoom_popup')
        && !target.hasClass('color_zoom_popup_svg')) {

          const totalsSorted = $('.block-swatch-list .block-swatch input').map(function () {
          const val = $(this).attr('data-total-colors');
            return parseInt(val, 10) || 0;
          }).get().sort((a, b) => a - b);

          let isReturn = false;
          for (let index = 0; index < totalsSorted.length; index++) {
            // console.log('length', $('.color_selected_main .selected_item.coladded').length + 1);
            // console.log('totalsSorted', totalsSorted[index]);
            const valChecked = $('.block-swatch .block-swatch__radio:checked').attr('data-total-colors');
            if (($('.color_selected_main .selected_item.coladded').length + 1) > valChecked) {
              if (($('.color_selected_main .selected_item.coladded').length + 1) > totalsSorted[index] && ($('.color_selected_main .selected_item.coladded').length + 1) <= totalsSorted[index+1]) {
                // totalsSorted.splice(index, 1);
                upgradeVariantAfter($this);
                const varTitle = $(`.block-swatch-list .block-swatch input[data-total-colors="${totalsSorted[index+1]}"]`);
                // console.log('varTitle', varTitle);
                if (varTitle) {
                  $(`.block-swatch-list .block-swatch input[data-total-colors="${totalsSorted[index+1]}"]`).siblings('label.block-swatch__item').click();
                  isReturn = true;
                  break; 
                }
              }
            }
          }

          if (isReturn) {
              return;
          }
          
      //  let freeColorCount = [];
      //   $('variant-metacolor input').each(function () {
      //     const val = parseInt($(this).attr('data-free-colors'), 10);
      //     if (!isNaN(val)) {
      //       freeColorCount.push(val);
      //     }
      //   });
      //   if (freeColorCount.length > 0) {
      //     freeColorCount.sort(function(a, b) {
      //       return a - b;
      //     });
      //   }


      //   if (($('.block-swatch .block-swatch__radio:checked').attr('data-value') == '3 Ontwerpen' || $('.block-swatch .block-swatch__radio:checked').attr('data-value') == '3 Kleuren') && $('.color_selected_main .selected_item.coladded').length == 3) {
      //     upgradeVariantAfter($this);
      //     if ($(`.block-swatch-list .block-swatch input[data-value="4 Ontwerpen"]`)) {
      //       $(`.block-swatch-list .block-swatch input[data-value="4 Ontwerpen"]`).siblings('label.block-swatch__item').click();
      //     }
      //     if ($(`.block-swatch-list .block-swatch input[data-value="4 Kleuren"]`)) {
      //       $(`.block-swatch-list .block-swatch input[data-value="4 Kleuren"]`).siblings('label.block-swatch__item').click();
      //     } 
      //     return;
      //   }
          
      //   if (($('.block-swatch .block-swatch__radio:checked').attr('data-value') == '4 Ontwerpen' || $('.block-swatch .block-swatch__radio:checked').attr('data-value') == '4 Kleuren') && $('.color_selected_main .selected_item.coladded').length == 4) {
      //     upgradeVariantAfter($this);
      //     if ($(`.block-swatch-list .block-swatch input[data-value="6 Ontwerpen"]`)) {
      //       $(`.block-swatch-list .block-swatch input[data-value="6 Ontwerpen"]`).siblings('label.block-swatch__item').click();
      //     }
      //     if ($(`.block-swatch-list .block-swatch input[data-value="6 Kleuren"]`)) {
      //       $(`.block-swatch-list .block-swatch input[data-value="6 Kleuren"]`).siblings('label.block-swatch__item').click();
      //     }
      //     return;
      //   }

      
        let markFarbe = $('color-switcher.color-selection__image[aria-expanded="true"]');
        let colorImage = $(this).attr("data-file");
        let colorName = $(this).attr("data-name");
        let vendorName = $(this).attr("data-vendor");
        let variantId = $(this).attr("data-variant");
        let colorPriceVal = parseFloat($this.attr("data-price")) || 0;
        let discountPercent = parseFloat($('#pick-color-id').attr('data-required-off')) || 0;
        let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
        let finalPrice = discountedPrice;
        var count = markFarbe.closest('.color-selection__grid-item').attr('data-count');
       
        markFarbe.attr('variant-name', colorName);
        markFarbe.attr('variant-id', variantId);
        markFarbe.attr('variant-img', colorImage);
        markFarbe.attr('data-original-price', colorPriceVal);
          
        markFarbe.css('backgroundImage', `url(${colorImage})`);
        markFarbe.siblings('.farbe-title').text(colorName);
        markFarbe.siblings('.farbe-vendor').text(vendorName);
        markFarbe.addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').addClass('coladded');
        markFarbe.removeClass('readytoselect');
        
        markFarbe.attr('data-price', finalPrice);
        markFarbe.attr('data-percent', discountPercent);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
        markFarbe.attr('data-compare', colorPriceVal);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
          
        if (markFarbe.hasClass('optional-switcher')) {

            let discountPercent = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
            let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
            let finalPrice = discountedPrice;
              
            markFarbe.attr('data-price', finalPrice);
            markFarbe.attr('data-percent', discountPercent);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
            markFarbe.attr('data-compare', colorPriceVal);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));         

            var countTotal = parseInt(markFarbe.closest('#pick-color-id').attr('data-total-colors'));
            var basicCount = $('#pick-color-id .color-selection__grid-item').length;
            var dataPercent = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-off'));
            var countTotalOptional = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-colors'));
            let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
          
            let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
          
            if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
                let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${basicCount+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                   <span class="discounted_percent">-${dataPercent}%</span>
                   <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${basicCount+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                      <button class="remove_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                   </color-switcher>
                   <div class="farbe-title">${window.translationsText.optionale}</div>
                   <div class="farbe-vendor"></div>
                   <div class="farbe-price_wrapper">
                      <div class="farbe-price"></div>
                      <div class="farbe-compare"></div>
                   </div>
                </div>`;
            $('.color-selection__container .color-selection__grid').append(newItemHtml)

            }

        }

        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
      
        if (!$("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $('color-choose-drawer#color-choose-drawer').removeAttr('open');
          $('html').removeClass('lock-all');
        }
          
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded').length);

        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
      
        updateCounter();
          
        let colorNameSelected = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
        $('.rosegold_inner').show();
        $('.rosegold_heading p').html(`${colorNameSelected} succesvol geselecteerd`);
        // $('.design_combinations_inner').hide();
        $('.press_nail_inner').show();

        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          updateColorDrawerSlider();
          // $this.addClass('active');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
          // $('.color_selected_main .selected_item:not(.coladded)').first().css('backgroundImage', `url(${colorImage})`);
          // $('.color_selected_main .selected_item:not(.coladded)').first().attr('variant-id', variantId);
          // $('.color_selected_main .selected_item:not(.coladded)').first().addClass('coladded');
        }
    
        } // target.hasClass if end here
    });



  function upgradeVariantAfter($this) {
    const variantPoller = setInterval(() => {
      if (window.variantChanged === true) {
        clearInterval(variantPoller);
       let freeColorCount = [];
        $('variant-metacolor input').each(function () {
          const val = parseInt($(this).attr('data-free-colors'), 10);
          if (!isNaN(val)) {
            freeColorCount.push(val);
          }
        });
        if (freeColorCount.length > 0) {
          freeColorCount.sort(function(a, b) {
            return a - b;
          });
        }
          

        let markFarbe = $('color-switcher.color-selection__image[aria-expanded="true"]');
        let colorImage = $this.attr("data-file");
        let colorName = $this.attr("data-name");
        let vendorName = $this.attr("data-vendor");
        let variantId = $this.attr("data-variant");
        
        let colorPriceVal = parseFloat($this.attr("data-price")) || 0;
        let discountPercent = parseFloat($('#pick-color-id').attr('data-required-off')) || 0;
        let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
        let finalPrice = discountedPrice;
        
        let count = markFarbe.closest('.color-selection__grid-item').attr('data-count');
       
        markFarbe.attr('variant-name', colorName);
        markFarbe.attr('variant-id', variantId);
        markFarbe.attr('variant-img', colorImage);
        markFarbe.attr('data-original-price', colorPriceVal);
          
        markFarbe.css('backgroundImage', `url(${colorImage})`);
        markFarbe.siblings('.farbe-title').text(colorName);
        markFarbe.siblings('.farbe-vendor').text(vendorName);
        markFarbe.addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').addClass('coladded');
        markFarbe.removeClass('readytoselect');

        markFarbe.attr('data-price', finalPrice);
        markFarbe.attr('data-percent', discountPercent);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
        markFarbe.attr('data-compare', colorPriceVal);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
      
        if (markFarbe.hasClass('optional-switcher')) {
            let discountPercent = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
            let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
            let finalPrice = discountedPrice;
              
            markFarbe.attr('data-price', finalPrice);
            markFarbe.attr('data-percent', discountPercent);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
            markFarbe.attr('data-compare', colorPriceVal);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
          
            var countTotal = parseInt(markFarbe.closest('#pick-color-id').attr('data-total-colors'));
            var basicCount = $('#pick-color-id .color-selection__grid-item').length;
            var dataPercent = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-off'));
            var countTotalOptional = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-colors'));
            let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
          
            let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
          
            if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
              
                let newItemHtml = `<div class="color-selection__grid-item optional-switcher test" data-percent="${dataPercent}" data-count="${basicCount+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                   <span class="discounted_percent">-${dataPercent}%</span>
                   <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${basicCount+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                      <button class="remove_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                   </color-switcher>
                   <div class="farbe-title">${window.translationsText.optionale}</div>
                   <div class="farbe-vendor"></div>
                   <div class="farbe-price_wrapper">
                      <div class="farbe-price"></div>
                      <div class="farbe-compare"></div>
                   </div>
                </div>`;
              
              $('.color-selection__container .color-selection__grid').append(newItemHtml)

            }

        }

        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
          
        if (!$("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $('color-choose-drawer#color-choose-drawer').removeAttr('open');
          $('html').removeClass('lock-all');
        }
          
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded').length);

        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
      
        updateCounter();
          
        let colorNameSelected = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
        $('.rosegold_inner').show();
        $('.rosegold_heading p').html(`${colorNameSelected} succesvol geselecteerd`);
        // $('.design_combinations_inner').hide();
        $('.press_nail_inner').show();

        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          updateColorDrawerSlider();
          // $this.addClass('active');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
          // $('.color_selected_main .selected_item:not(.coladded)').first().css('backgroundImage', `url(${colorImage})`);
          // $('.color_selected_main .selected_item:not(.coladded)').first().attr('variant-id', variantId);
          // $('.color_selected_main .selected_item:not(.coladded)').first().addClass('coladded');
        }
      }
    }, 200);
  }


  
    $('body').on('click', 'color-switcher.color-selection__image .remove_item', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();
        var $parent = $(this).parents('.color-selection__grid-item');
        $parent.removeClass('coladded');
        var count = parseInt($parent.attr('data-count'));
        var totalCount = parseInt($parent.attr('data-total-count'));
        var $img = $parent.children('.color-selection__image--top');
        $parent.children('.color-selection__image').removeAttr('data-price');
        $parent.children('.color-selection__image').removeAttr('data-compare');
        $parent.children('.farbe-price_wrapper').find('.farbe-price').html('');
        $parent.children('.farbe-price_wrapper').find('.farbe-compare').html('');
        if ($parent.hasClass('optional-switcher')) {
            var countTotal = parseInt($parent.attr('data-total-count'));
            $parent.children('.farbe-title').text('Optionales Design');
            var visibleCount = $('.color-selection__grid-item.optional-switcher').length;

            if (visibleCount > 1) {
                $parent.remove();

                  let indexerOptional = parseInt($('#pick-color-id').attr('data-free-colors'));
                  $('.color-selection__grid-item.optional-switcher').each(function (index) {
                    indexerOptional += 1;
                    $(this).attr('data-count', indexerOptional);
                  })
              
                  var countTotal = parseInt($('#pick-color-id').attr('data-total-colors'));
                  var dataPercent = parseInt($('#pick-color-id').attr('data-optional-off'));
                  var countTotalOptional = parseInt($('#pick-color-id').attr('data-optional-colors'));
                  let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
                
                  let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
                
                  if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
                      let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${indexerOptional+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                         <span class="discounted_percent">-${dataPercent}%</span>
                         <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${indexerOptional+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                            <button class="remove_item">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                         </color-switcher>
                         <div class="farbe-title">${window.translationsText.optionale}</div>
                         <div class="farbe-vendor"></div>
                         <div class="farbe-price_wrapper">
                            <div class="farbe-price"></div>
                            <div class="farbe-compare"></div>
                         </div>
                      </div>`;
                    
                    $('.color-selection__container .color-selection__grid').append(newItemHtml)
      
                  }
            } else {
                $(`.color-selection__grid-item.optional-switcher[data-count="${count}"]`).children('.color-selection__image').addClass('readytoselect')
            }
          
        } else {
            $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-title').text(`${window.translationsText.design} ${count}`);
        }
        $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-vendor').text('');

        $parent.children('.color-selection__image').removeAttr('variant-name');
        $parent.children('.color-selection__image').removeAttr('variant-id');
        $parent.children('.color-selection__image').removeAttr('variant-img');
        $img.removeAttr('style');
        $img.removeClass('coladded');
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded:not(.disabled-color)').length);

        $('.color-selection__grid-item .color-selection__image.readytoselect').removeClass('readytoselect');
        $('.color-selection__grid-item .color-selection__image').attr("aria-expanded", "false");
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
        updateCounter();

        if ($('color-switcher.color-selection__image.coladded').length > 0) {
          let colorNam = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
          $('.rosegold_heading p').html(`${colorNam} succesvol geselecteerd`);
        } else {
          $('.rosegold_inner').hide();
          $('.press_nail_inner').hide();
          // $('.design_combinations_inner').show();
        }

         if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
            updateColorDrawerSlider();
            // if ($(`color-switcher.color-selection__image.coladded[variant-id=${variantId}]`).length > 0) {
            //  $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().removeClass('coladded');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().removeAttr('variant-id');
            // } else {
            //    $(`.product-tile-item.active[data-variant=${variantId}]`).removeClass('active');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).removeClass('coladded');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).removeAttr('variant-id');
            // }
          
          }
      
    });

    $('body').on('click', '.product-tile-item .quantity_minus', function (evt) {
      let varID = $(this).closest('.product-tile-item').attr('data-variant');
      $(`color-switcher.color-selection__image.coladded[variant-id="${varID}"]`).last().find('.remove_item').click();
    });

  
function updateColorDrawerSlider() {
    if ($('.color_selected_main .selected_item').length > 0) {
      $('.color_selected_main .selected_item').each(function () {
        const index = $(this).attr('data-index');
        if ($(`.color-selection__grid-item.coladded[data-count="${index}"]:not(.disabled-color)`) && $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-id')) {
          let imgURL = $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-img');
          let varID = $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-id');
          $(this).css('backgroundImage', `url(${imgURL})`);
          $(this).addClass('coladded');
          $(this).attr('variant-id', varID);
        } else {
          $(this).css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
          $(this).removeClass('coladded');
          $(this).removeAttr('variant-id');
        }
      })
    }
    if ($('color-switcher.color-selection__image.coladded').length > 0) {
      $('#color-choose-drawer .product-tile-item').removeClass('active');
      $('#color-choose-drawer .product-tile-item').find('input.quantity-selector__input').val(1);
      $('color-switcher.color-selection__image.coladded').each(function () {
        const varId = $(this).attr('variant-id');
        $(`#color-choose-drawer .product-tile-item[data-variant="${varId}"]`).addClass('active');
        $(`#color-choose-drawer .product-tile-item[data-variant="${varId}"]`).find('input.quantity-selector__input').val($(`color-switcher.color-selection__image.coladded[variant-id="${varId}"]`).length);
      })
    } else {
      $('#color-choose-drawer .product-tile-item').removeClass('active');
    }
    if ($('.color_selected_main .selected_item.coladded').length > 0) {
      $('.color_choose_guarantee_inner').addClass('active');
    } else {
      $('.color_choose_guarantee_inner').removeClass('active')
    }
    
    let freeColorCount = [];
    $('variant-metacolor input').each(function () {
      const val = parseInt($(this).attr('data-free-colors'), 10);
      if (!isNaN(val)) {
        freeColorCount.push(val);
      }
    });
    if (freeColorCount.length > 0) {
      freeColorCount.sort(function(a, b) {
        return a - b;
      });
    }
    
    if (($(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-title') || '').toLowerCase() == ($('.block-swatch .block-swatch__radio:checked').attr('data-value') || '').toLowerCase()) {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[2]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    } else if (($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-title') || '').toLowerCase() == ($('.block-swatch .block-swatch__radio:checked').attr('data-value') || '').toLowerCase()) {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[1]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    } else {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[0]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    }
      
  if (!$('body').hasClass('all_in_one_special_set')) {

    if (($(`variant-metacolor input[data-free-colors="${freeColorCount[0]}"]`).attr('data-title') || '').toLowerCase() == ($('.block-swatch .block-swatch__radio:checked').attr('data-value') || '').toLowerCase()) {
      if ($('.color_selected_main .selected_item.coladded').length == freeColorCount[0]) {
        const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-required-off');
        $('.product-item__label-list .label').hide();
        $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
        $('.product-item__label-list .percentOff').show();
      }
      if ($('.color_selected_main .selected_item.coladded').length >= freeColorCount[1]) {
        const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
        $('.product-item__label-list .label').hide();
        $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
        $('.product-item__label-list .percentOff').show();
      }
    } else if (($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-title') || '').toLowerCase() == ($('.block-swatch .block-swatch__radio:checked').attr('data-value') || '').toLowerCase()) {
      const totalOp = freeColorCount[1] + parseInt($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-optional-colors'));
      if ($('.color_selected_main .selected_item.coladded').length >= freeColorCount[1] && $('.color_selected_main .selected_item.coladded').length != totalOp) {
        const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-required-off');
        $('.product-item__label-list .label').hide();
        $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
        $('.product-item__label-list .percentOff').show();
      } else if ($('.color_selected_main .selected_item.coladded').length == totalOp) {
        const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
        $('.product-item__label-list .label').hide();
        $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
        $('.product-item__label-list .percentOff').show();
      }
    } else if (($(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-title') || '').toLowerCase() == ($('.block-swatch .block-swatch__radio:checked').attr('data-value') || '').toLowerCase()) {
        const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
        $('.product-item__label-list .label').hide();
        $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
        $('.product-item__label-list .percentOff').show();
    }
    
      

      if ($('.color_selected_main .selected_item.coladded').length < freeColorCount[0]) {
        $('.product-item__label-list .percentOff').html('');
        $('.product-item__label-list .percentOff').hide();
        $('.product-item__label-list .label:not(.percentOff)').show();
      }
      
    }
  }

$('.color_selected_inner .selection_button').on('click', function () {
  let freeColorCount = [];
  $('variant-metacolor input').each(function() {
    const val = parseInt($(this).attr('data-free-colors'), 10);
    if (!isNaN(val)) {
      freeColorCount.push(val);
    }
  });
  if (freeColorCount.length > 0) {
    freeColorCount.sort(function(a, b) {
      return a - b;
    });
  }

  for (let index = 0; index < freeColorCount.length; index++) {
    if (freeColorCount[index] == $('.color_selected_main .selected_item.coladded').length) {
      const varTitle = $(`variant-metacolor input[data-free-colors="${freeColorCount[index]}"]`).attr('data-title');
      $(`.block-swatch-list .block-swatch input[data-value="${varTitle}"]`).siblings('label.block-swatch__item').click();
    }
  }
  
  $('.popup-close.close-icon-popup').click();
})


    $('body').on('click', '#MainPaymentContainer', function(evt) {
        if ($(this).find('#AddToCart').attr('disabled') == 'disabled') {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            $('html, body').animate({
                scrollTop: $(".product__info form.shopify-product-form").offset().top - 50
            }, 10);
            setTimeout(() => {
                $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
            }, 100);
        }
    });

//   document.addEventListener('click', (event) => {
//   const targetElement = event.target; 
//   // Now you can use targetElement to access properties and methods of the clicked element
//   console.log(targetElement); 
//     console.log(event); 
// });

    $('body').on('click', '.custom-new-upsell', function(evt) {
        if ($(this).find('.remover_upsell').attr('disabled') == 'disabled') {

            evt.preventDefault();
            evt.stopImmediatePropagation();
            $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
        }
    });




    $('.color_choose_arrow').click(function() {
        let scroll = 100;
        if ($(this).hasClass('prev-arrow')) scroll *= -1;
        $('.color-filter-link-bar .link-bar__scroller').animate({
            scrollLeft: ($('.color-filter-link-bar .link-bar__scroller').scrollLeft() + scroll)
        }, 500);

    })


    $('.bullets-question_mark.Nagelkleber').click(function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if ($(this).siblings('.Nagelkleber_content').is(":visible")) {
            $(this).text('?');
            $(this).siblings('.Nagelkleber_content').fadeOut();
        } else {
            $(this).text('x');
            $(this).siblings('.Nagelkleber_content').fadeIn();
        }

    })

    // $('whats-in-set#whats-in-set .product-tile-item').hover(

    //     function() { // Mouse enter function
    //         console.log('enter')
    //         $(this).find('.bullets-question_mark.Nagelkleber').text('x');
    //         $(this).find('.Nagelkleber_content').fadeIn();
    //     },
    //     function() { // Mouse leave function
    //         console.log('exit')
    //         $(this).find('.bullets-question_mark.Nagelkleber').text('?');
    //         $(this).find('.Nagelkleber_content').fadeOut();
    //     }
    // );

    // $("body").on('click', function(event) {
    //     if (!$(event.target).closest('color-choose-drawer#color-choose-drawer').length) {
    //         $('.color-selection__image').each(function(){
    //           $(this).closest('.color-selection__grid-item').removeClass('active');
    //           $(this).attr("aria-expanded", "false");
    //         })
    //         $('color-choose-drawer#color-choose-drawer').removeAttr('open');
    //         $('html').removeClass('lock-all');

    //     } 
    //   if (!$(event.target).closest('whats-in-set#whats-in-set').length){
    //     $('.whats-in-set[aria-controls="whats-in-set"]').attr("aria-expanded", "false"); 
    //       $('whats-in-set#whats-in-set').removeAttr('open');
    //     $('html').removeClass('lock-all');
    //   }
    // });


    $("color-choose-drawer#color-choose-drawer .popup-close").on('click', function(event) {
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
        $('color-choose-drawer#color-choose-drawer').removeAttr('open');
        $('html').removeClass('lock-all');
    });

      $("color-choose-drawer#color-choose-drawer .drawer__overlay").on('click', function(event) {
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
        $('color-choose-drawer#color-choose-drawer').removeAttr('open');
        $('html').removeClass('lock-all');
    });


    $("body").on(
        "click",
        ".products_filters_sortby .popout__toggle",
        function() {
            let $this = $(this);
            $(".products_filters_sortby .popout-list").slideToggle(function() {
                if ($(this).is(":visible")) {
                    $this.find(".down_close").css("transform", "rotate(180deg)");
                } else {
                    $this.find(".down_close").css("transform", "rotate(0deg)");
                }
            });
        }
    );

    $("body").on("click", "[data-sort-link]", function(evt) {
        evt.preventDefault();
        let valueSort = $(this).attr("data-value");
        let collectionHandle = $(this)
            .closest(".popout-list")
            .attr("data-collection");
        $(this).closest(".popout-list__item").addClass('active');
      $(this).closest(".popout-list__item").siblings().removeClass('active');
        $.ajax({
            url: `/collections/${collectionHandle}?view=set-bundle-sort&sort_by=${valueSort}`,
            type: "GET",
            success: function(response) {
                $('color-choose-drawer#color-choose-drawer').find(".products-tiles").html(response);
            },
            error: function(xhr, status, error) {
                // Handle any errors
                console.error("Error:", error);
            },
        });
    });

    // $(".option-popup .popup-inner .tags").slideDown();
    $("a.filters-pop").click(function(e) {
        e.preventDefault();

      if ($(".option-popup .popup-inner .tags").hasClass('active')) {
        $(".option-popup .popup-inner .tags").slideUp();
        $(".option-popup .popup-inner .tags").removeClass('active')
      } else {
        $(".option-popup .popup-inner .tags").slideDown();
        $(".option-popup .popup-inner .tags").addClass('active')
      }
        // $(".option-popup .popup-inner .tags").slideToggle();
        $(".sort-section").slideToggle();
        $(".search-area").slideUp();
    });

    $("a.search-pop").click(function(e) {
        e.preventDefault();
        $(".option-popup .popup-inner .tags").slideUp();
       $(".sort-section").slideUp();
        $(".search-area").slideToggle();
    });
  
    $(".tags-option1 .tag-wrapper").click(function() {
      if (!$(this).hasClass('disabled')) {
        var selectedTag1 = $(this).data("value");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            selectedTag1 = null;
        } else {
            $(".tags-option1 .tag-wrapper").removeClass("active");
            $(this).addClass("active");
        }
        filterProductTiles(selectedTag1, getSelectedTag(".tags-option2"));
        updateDisabledStateNew(selectedTag1, "tags-option1");
        
      }
    });

    $(".tags-option2 .tag-wrapper").click(function() {
      if (!$(this).hasClass('disabled')) {
        var selectedTag2 = $(this).data("value");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            selectedTag2 = null;
        } else {
            $(".tags-option2 .tag-wrapper").removeClass("active");
            $(this).addClass("active");
        }
        filterProductTiles(getSelectedTag(".tags-option1"), selectedTag2);
         updateDisabledStateNew(selectedTag2, "tags-option2");
      }
    });

    function getSelectedTag(selector) {
        return $(selector + " .tag-wrapper.active").data("value");
    }

    function filterProductTiles(tag1, tag2) {
        $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
            var classes = $(this).attr("class").split(" ");
            var formClass, langeClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i];
                } else if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i];
                }
            }

            var showTile =
                (!tag1 || (formClass && formClass.split("_")[1] === tag1)) &&
                (!tag2 || (langeClass && langeClass.split("_")[1] === tag2));
            $(this).toggle(showTile);
        });
      
    }

    // function updateDisabledStateOld(tag1, tag2, option) {
    //     $(option + " .tag-wrapper").removeClass("disabled");
    //     if (tag1 || tag2) {
    //         $(option + " .tag-wrapper").each(function() {
    //             var selectedTag = $(this).data("value");
    //             if (option === ".tags-option1") {
    //                 if (!tag2 && tag1 !== selectedTag) {
    //                     $(this).addClass("disabled");
    //                 }
    //             } else {
    //                 if (!tag1 && tag2 !== selectedTag) {
    //                     $(this).addClass("disabled");
    //                 }
    //             }
    //         });
    //     }
    // }

    // function updateDisabledState(tag1, tag2, option) {
    //     var tilesWithTagsB = [];

    //     var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item:visible");
    //     visibleTiles.each(function() {
    //         var classes = $(this).attr("class").split(" ");
    //         var langeClass;
    //         for (var i = 0; i < classes.length; i++) {
    //             if (classes[i].startsWith("plange_")) {
    //                 langeClass = classes[i].split("_")[1];
    //                 tilesWithTagsB.push(langeClass);
    //                 break;
    //             }
    //         }
    //     });

    //     $(option + " .tag-wrapper").removeClass("disabled");
    //     $(option + " .tag-wrapper").each(function() {
    //         var selectedTag = $(this).data("value");
    //         if (!tilesWithTagsB.includes(selectedTag)) {
    //             $(this).addClass("disabled");
    //         }
    //     });
    // }

    function updateDisabledStateNew(tag, option) {
        var tilesWithTagsA = [];
        var tilesWithTagsB = [];

        var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item:visible");
        visibleTiles.each(function() {
            var classes = $(this).attr("class").split(" ");
            var langeClass;
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i].split("_")[1];
                    tilesWithTagsB.push(langeClass);
                }
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    tilesWithTagsA.push(formClass);
                }
            }
        });

        $(".tags-option1 .tag-wrapper").removeClass("disabled");
      $(".tags-option2 .tag-wrapper").removeClass("disabled");
      
if (tag != null && option == 'tags-option1') {
  if ($(".tags-option2 .tag-wrapper.active").length == 0) {
        $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsB.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });
    
  } else {
    let dataVal = $(".tags-option1 .tag-wrapper.active").attr('data-value');
    let plangeArray = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.pform_${dataVal}`).each(function() {
      var classes = $(this).attr("class").split(" ");
            var langClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langClass = classes[i].split("_")[1];
                    plangeArray.push(langClass);
                }
            }
        });
    // console.log('plangeArray', plangeArray)
            $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!plangeArray.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
                // filterProductTiles(getSelectedTag(".tags-option1"), null);
            }
        });


    let dataVal2 = $(".tags-option2 .tag-wrapper.active").attr('data-value');
    let pformArray2 = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.plange_${dataVal2}`).each(function() {
      var classes2 = $(this).attr("class").split(" ");
            var formClass2;
            for (var i = 0; i < classes2.length; i++) {
                if (classes2[i].startsWith("pform_")) {
                    formClass2 = classes2[i].split("_")[1];
                    pformArray2.push(formClass2);
                }
            }
        });
        // console.log('pformArray2', pformArray2)
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!pformArray2.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
            }
        });


  }
}

  
if (tag != null && option == 'tags-option2') {      
  if ($(".tags-option1 .tag-wrapper.active").length == 0) {
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsA.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });
  } else {

        let dataVal = $(".tags-option2 .tag-wrapper.active").attr('data-value');
    let pformArray = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.plange_${dataVal}`).each(function() {
      var classes = $(this).attr("class").split(" ");
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    pformArray.push(formClass);
                }
            }
        });
        // console.log('pformArray', pformArray)
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!pformArray.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
                // filterProductTiles(null, getSelectedTag(".tags-option2"));
            }
        });

        let dataVal1 = $(".tags-option1 .tag-wrapper.active").attr('data-value');
    let plangeArray1 = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.pform_${dataVal1}`).each(function() {
      var classes1 = $(this).attr("class").split(" ");
            var langClass1;
            for (var i = 0; i < classes1.length; i++) {
                if (classes1[i].startsWith("plange_")) {
                    langClass1 = classes1[i].split("_")[1];
                    plangeArray1.push(langClass1);
                }
            }
        });
    // console.log('plangeArray1', plangeArray1)
            $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!plangeArray1.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
            }
        });

    
    }
  }



  updateDisabledStateStart();
}


  updateDisabledStateStart();
  
    function updateDisabledStateStart() {
        var tilesWithTagsA = [];
        var tilesWithTagsB = [];

        var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item");
        visibleTiles.each(function() {
            var classes = $(this).attr("class").split(" ");
            var langeClass;
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i].split("_")[1];
                    tilesWithTagsB.push(langeClass);
                }
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    tilesWithTagsA.push(formClass);
                }
            }
        });

      // console.log(tilesWithTagsB)
      
        $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsA.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });

     
        $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsB.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });

}
  

    $(".product-search").on("input", function() {
        var searchQuery = $(this).val().trim().toLowerCase();

        filterProductBySearch(searchQuery);
        toggleClearButton(searchQuery);
    });

    $(".clear-search-btn").on("click", function() {
        $(".product-search").val("").trigger("input").focus();
        $(this).hide();
    });

    $(".search_again").on("click", function() {
        $(".product-search").val("").trigger("input").focus();
    });

    function filterProductBySearch(searchQuery) {
      let allHide = true;
      $("color-choose-drawer .product-tile-item").each(function() {
          var productName = $(this).data("name");
          var keywords = $(this).data("keywords");
          if (productName) {
              productName = productName.toLowerCase();
              if (keywords) {
                keywords = keywords.toLowerCase();
              }
              var showTile = !searchQuery || productName.includes(searchQuery) || keywords.includes(searchQuery);
              var attributeValue = $(this).attr("hidden");
              if (typeof attributeValue == "undefined" || attributeValue == false) {
                $(this).toggle(showTile);
              }              
          }
          if ($(this).is(':visible')) {
            allHide = false;
          }
      });
      if (allHide) {
        $('.products-tiles-empty').show();
      } else {
        $('.products-tiles-empty').hide();
      }
    }

    function toggleClearButton(searchQuery) {
        $(".clear-search-btn").toggle(searchQuery.length > 0);
    }

    $('#AddToCart').attr('disabled', 'true');
    $('#StickyAddToCart').addClass('disabled');
    $('#AddToCart .loader-button__text').text(window.translationsText.buttonUnfilled + ' 1');


});

/*po set coding */
if ($('.custom-po-set').length > 0) {
    $(window).on('load', function() {
        // PoSetRefresh($('input[name="option1"]:checked').val());
        const firstOptionSelector = document.querySelector('.custom-po-set .block-swatch__radio:checked');
        if (firstOptionSelector) { PoSetRefresh(firstOptionSelector.getAttribute('data-value')); } /* Sentry 2026-09-19 (DE-1ZS): kein vorgewaehlter Swatch */
    });
    document.addEventListener('variant:changed', function(event) {
        let variant = event.detail.variant;
        $('#AddToCart[data-product-add-to-cart-button]').attr('data-price', variant.price);
        PoSetRefresh(variant.title);
    });
}

function PoSetRefresh(variant_title) {

  const firstOptionSelector = $('.custom-po-set .block-swatch__radio:checked');
  let selectedIndex = firstOptionSelector.attr('data-index');
  let selectedValue = firstOptionSelector.attr('data-value');
    $('.free_top_svg').attr('data-index', selectedIndex);
  
      // if (selectedValue == '5 Designs') {
      //    $('.free_product_col').each(function (index) {
      //         $(this).removeClass('notAdded');
      //         $(this).addClass('coladded');
      //   });
      // }
  
 let variant_title_down = selectedValue.toLowerCase();
 variant_title_down = variant_title_down.trim();
 variant_title_down = variant_title_down.replace(/[\s+]/g, "_");
 let variant_id = $('.product-form__buy-buttons input[name="id"]').val();

 let allow_colors = parseInt($(`variant-metacolor input[value="${variant_id}"]`).attr('data-free-colors'));
 let optional_colors = parseInt($(`variant-metacolor input[value="${variant_id}"]`).attr('data-optional-colors'));


  
 $('.set-no-color').text(allow_colors);

    $('color-switcher.color-selection__image.required-switcher').each(function() {
        if (parseInt($(this).closest('.color-selection__grid-item').attr('data-count')) > allow_colors) {

            $(this).closest('.color-selection__grid-item').removeClass('coladded');
            $(this).closest('.color-selection__grid-item').addClass('disabled-color');
            $(this).removeAttr('style');
            $(this).removeClass('coladded');
            $(this).removeClass('active');
            $(this).removeAttr('variant-name');
            $(this).removeAttr('variant-id');
            $(this).removeAttr('variant-img');
            $(this).siblings('.farbe-title').html(`${window.translationsText.design} ${$(this).closest('.color-selection__grid-item').attr('data-count')}`);
            $(this).siblings('.farbe-vendor').html('');
            $(this).closest('.color-selection__grid-item').hide();
        } else {
            $(this).closest('.color-selection__grid-item').removeClass('disabled-color');
            $('.color-selection__grid-item.required-switcher').each(function () {
              if (!$(this).hasClass('coladded')) {
                let optionalItem = $('.color-selection__grid-item.optional-switcher.coladded').first();
                
                if (optionalItem.length > 0) {         
                  
                $(this).find('color-switcher.color-selection__image.required-switcher').attr('variant-name', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('variant-name'));
                $(this).find('color-switcher.color-selection__image.required-switcher').attr('variant-id', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('variant-id'));
                $(this).find('color-switcher.color-selection__image.required-switcher').attr('variant-img', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('variant-img'));
                $(this).find('color-switcher.color-selection__image.required-switcher').attr('style', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('style'));
                $(this).find('.farbe-title').html(optionalItem.find('.farbe-title').html());
                $(this).find('.farbe-vendor').html(optionalItem.find('.farbe-vendor').html());
                $(this).addClass('coladded')
                $(this).find('color-switcher.color-selection__image.required-switcher').addClass('coladded');
                optionalItem.remove();
                  
                }
              }
            })
            $(this).closest('.color-selection__grid-item').show();
        }
    })

  $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded:not(.disabled-color)').length); 
  
        $(`.hide_on_other_variant`).hide();
        setTimeout(() => {
          $(`.show_${variant_title_down}`).show();
          $(`.show_all_variant`).show();
        }, 50);
      
        var countTotalOptional = optional_colors;
        var currentCount = allow_colors + 1;
        var percentOff = $('#pick-color-id').attr('data-optional-off'); 
  
    updateCounter()
}

$("body").on("change", '.optional_accessories_block_product_item', function(evt) {
   updateCounter(); 
});

function updateCounter() {
    setTimeout(() => {
        let selectedNo = parseInt($('.set-no-color_selected').first().text());
        let selectedTotal = parseInt($('.set-no-color').first().text());
        if (selectedNo == selectedTotal) {
          $('.rosegold_text p').text('Ziet er geweldig uit! Je set is klaar!');
          $('.color-selection__label_text .unfilled').css('color', '#78A97C')
          $('.fl-select.unfilled').css('color', '#78A97C');
          let atcPrice = parseInt($('[data-product-price-list] .price[data-price]').attr('data-price'));
          let atcPriceCompare = parseInt($('[data-product-price-list] .price[data-compare]').attr('data-compare'));

          var requiredPercentOff = $('#pick-color-id').attr('data-required-off');
          if (requiredPercentOff) {
            atcPrice = 0;
            atcPriceCompare = 0;
            requiredPercentOff = parseInt(requiredPercentOff);
            $('color-switcher.color-selection__image.required-switcher.coladded').each(function() {
                const requiredPrice = parseInt($(this).attr('data-original-price'));
                const discountedPrice = requiredPrice - (requiredPrice * (requiredPercentOff / 100));
                atcPrice += Math.round(discountedPrice);
                atcPriceCompare += requiredPrice;
            })
          }
        
          if ($('color-switcher.color-selection__image.optional-switcher.coladded').length > 0) {
            $('color-switcher.color-selection__image.optional-switcher.coladded').each(function() {
                let optionalPrice = parseInt($(this).attr('data-price'));
                atcPrice += optionalPrice;
                let optionalPriceCompare = parseInt($(this).attr('data-compare'));
                atcPriceCompare += optionalPriceCompare;
            })
          }

          if ($('.optional_accessories_block_product_item:checked').length > 0) {
              $('.optional_accessories_block_product_item:checked').each(function() {
                  let optionalPrice = parseInt($(this).attr('data-discount-price'));
                  atcPrice += optionalPrice;
                  let optionalPriceCompare = parseInt($(this).attr('data-original-price'));
                  atcPriceCompare += optionalPriceCompare;
              })
          }

          $('#AddToCart[data-product-add-to-cart-button] .loader-button__text').html(`Toevoegen aan mandje | <span class="atc_copmare_btn">${window.globalMoneyFm(atcPriceCompare)}</span> <span class="atc_price_btn">${window.globalMoneyFm(atcPrice)}</span>`);
          $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
          $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
          $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
          $('#AddToCart[data-product-add-to-cart-button]').removeAttr('disabled');
          window.atcPrice = atcPrice;
          window.atcPriceCompare = atcPriceCompare;

        } else {

              let atcPrice = parseInt($('[data-product-price-list] .price[data-price]').attr('data-price'));
              let atcPriceCompare = parseInt($('[data-product-price-list] .price[data-compare]').attr('data-compare'));
  
              var requiredPercentOff = $('#pick-color-id').attr('data-required-off');
              if (requiredPercentOff) {
                atcPrice = 0;
                atcPriceCompare = 0;
                requiredPercentOff = parseInt(requiredPercentOff);
                $('color-switcher.color-selection__image.required-switcher.coladded').each(function() {
                    const requiredPrice = parseInt($(this).attr('data-original-price'));
                    const discountedPrice = requiredPrice - (requiredPrice * (requiredPercentOff / 100));
                    atcPrice += Math.round(discountedPrice);
                    atcPriceCompare += requiredPrice;
                })
              }
            
              if ($('color-switcher.color-selection__image.optional-switcher.coladded').length > 0) {
                $('color-switcher.color-selection__image.optional-switcher.coladded').each(function() {
                    let optionalPrice = parseInt($(this).attr('data-price'));
                    atcPrice += optionalPrice;
                    let optionalPriceCompare = parseInt($(this).attr('data-compare'));
                    atcPriceCompare += optionalPriceCompare;
                })
              
                $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
                $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
               $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
            } else {
                $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
                $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
                $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
            }

            $('.rosegold_text p').text('Geweldige look! Kies je volgende Design');
            $('.color-selection__label_text .unfilled').css('color', '#272727');
            $('.fl-select.unfilled').css('color', '#272727');
            $('#AddToCart .loader-button__text').text(`${window.translationsText.buttonUnfilled} ${selectedNo + 1}`);
            $('.color-selection__grid-item:not(.disabled-color) .color-selection__image.readytoselect').removeClass('readytoselect');
            $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
            $('#AddToCart[data-product-add-to-cart-button]').attr('disabled', 'true');
        }

                  let optionalLengthNotSelected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
      // console.log(optionalLengthNotSelected)
        if (optionalLengthNotSelected > 1) {
          $('.color-selection__grid-item.optional-switcher:not(.coladded)').each(function (index) {
            if (index > 0) {
              $(this).remove();
            } else {
              let foundNotSelected = false;
              $('.color-selection__grid-item.required-switcher').each(function () {
                if (!$(this).hasClass('coladded') && !$(this).hasClass('disabled-color')) {
                  foundNotSelected = true;
                } else {
                  $(this).find('color-switcher.color-selection__image').removeClass('readytoselect')
                }
              })
              if (!foundNotSelected) {
                $(this).find('color-switcher.color-selection__image.optional-switcher:not(.coladded)').addClass('readytoselect')
              }
              
            }
           
          })
        } else {
              let foundNotSelected = false;
              $('.color-selection__grid-item.required-switcher').each(function () {
                if (!$(this).hasClass('coladded') && !$(this).hasClass('disabled-color')) {
                  foundNotSelected = true;
                } else {
                  $(this).find('color-switcher.color-selection__image').removeClass('readytoselect')
                }
              })
              if (!foundNotSelected) {
                $('color-switcher.color-selection__image.optional-switcher:not(.coladded)').addClass('readytoselect')
              }
          
        }

      
    }, 200);
}

$(document).ready(function() {


  
document.addEventListener("doc:rerendered", (event) => {
  updateCounter();
})

  
    $(".shopify-section-custom_accordion .collapsible-toggle").click(function(event) {
        event.preventDefault();
        let clickedEle = $(this);
        let ariaExp = clickedEle.attr('aria-expanded')
        $(this).addClass('clicked')
        $(".shopify-section-custom_accordion .collapsible-toggle:not(.clicked)").each(function() {
            $(this).attr('aria-expanded', 'false');
            $(this).siblings('collapsible-content').removeAttr('open');
        })

        if (ariaExp != 'false') {
            $(this).removeClass('clicked')
        }

    });

  
});

/* DN 2026-10-03: gemerkte Designs (window.dnRfUeber, siehe variant:changed) verfallen, sobald die Kundin selbst waehlt oder
   entfernt - nur echte Klicks (isTrusted); das Nachfuellen per processVariants klickt programmatisch. */
document.addEventListener('click', function (e) {
  if (!e.isTrusted || !window.dnRfUeber || !window.dnRfUeber.length || !e.target.closest) return;
  if (e.target.closest('color-choose-drawer#color-choose-drawer .product-tile-item, [data-dn-cc-weg], #pick-color-id .remove_item')) window.dnRfUeber = [];
}, true);

/* DN 2026-10-03: Auswahl beim Klick auf eine Set-Karte merken, bevor das Theme sie auf die neue Variante kuerzt - beim variant:changed
   stehen bei 6 -> 4 nur noch 4 Designs (gemessen live: change 6, variant:changed 4). Capture, wie dn-refill-felder-start. */
document.addEventListener('change', function (e) {
  if (!e.target || !e.target.closest || !e.target.closest('variant-picker.refill-pr-on-set')) return;
  window.dnRfVorher = $('#pick-color-id color-switcher.color-selection__image.coladded').map(function () { return $(this).attr('variant-id'); }).get();
}, true);
